export const heroSlides = [
  {
    id: 'hero-frieren',
    tag: '焦点资讯',
    title: '《葬送的芙莉莲》第二季定档，旅途继续',
    summary:
      '官方公开首张主视觉与播出窗口，故事将从“黄金乡”篇章继续。时间对精灵几乎静止，每一次告别却值得被认真记录。',
    meta: '2026.10.15 · 新番情报 · 阅读 18,420',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20style%20cinematic%20wide%20illustration%20of%20a%20white%20haired%20elf%20mage%20walking%20through%20a%20vast%20windswept%20grassland%20at%20golden%20hour%2C%20soft%20teal%20sky%20with%20warm%20amber%20sunlight%2C%20distant%20mountains%20and%20floating%20light%20particles%2C%20painterly%20digital%20art%2C%20atmospheric%20haze%2C%20epic%20wide%20composition&width=1600&height=900&seq=hero-grassland-elf&orientation=landscape',
    to: '/detail/news/frieren-s2',
    label: '阅读全文',
  },
  {
    id: 'hero-cyberpunk',
    tag: '文化专题',
    title: '赛博朋克在东亚：霓虹、义体与城市焦虑',
    summary:
      '赛博朋克诞生于西方，却把最浓的视觉乡愁留给了东亚城市。这是一种想象，也是一面镜子。',
    meta: '林砚 · 15 分钟深度阅读 · 城市与视觉文化',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20style%20cinematic%20wide%20illustration%20of%20a%20rain%20soaked%20East%20Asian%20megacity%20at%20night%2C%20layered%20neon%20signs%20in%20deep%20teal%20and%20warm%20amber%2C%20reflections%20on%20wet%20streets%2C%20lone%20figure%20with%20umbrella%2C%20painterly%20digital%20art%2C%20atmospheric%20fog%2C%20cinematic%20depth&width=1600&height=900&seq=hero-neon-city&orientation=landscape',
    to: '/detail/culture/cyberpunk-east-asia',
    label: '阅读专题',
  },
  {
    id: 'hero-ink',
    tag: '作品推荐',
    title: '雾山五行：把水墨的笔势带进动作场面',
    summary:
      '不依赖密集特效，而用留白、墨色浓淡与构图传达冲击。这是近年最值得反复观看的国产动作动画之一。',
    meta: '国产动画 · 水墨美学 · 评分 8.8',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20style%20cinematic%20wide%20illustration%20of%20ink%20wash%20mountains%20emerging%20from%20teal%20mist%20with%20golden%20sunlight%2C%20a%20tiny%20boat%20on%20a%20quiet%20river%2C%20traditional%20Chinese%20painting%20blended%20with%20modern%20animation%2C%20painterly%20digital%20art%2C%20dramatic%20wide%20composition&width=1600&height=900&seq=hero-ink-mountains&orientation=landscape',
    to: '/detail/works/fog-hill',
    label: '查看作品',
  },
];

export const siteStats = [
  { label: '资讯条目', value: '1,280+' },
  { label: '作品档案', value: '460+' },
  { label: '文化专题', value: '86' },
  { label: '每周更新', value: '40 篇' },
];

export const popularTags = [
  '新番情报',
  '国产动画',
  '赛博朋克',
  '物哀美学',
  '声优',
  '分镜研究',
  '同人文化',
  '剧场版',
  '水墨动画',
  '产业观察',
  '奇幻',
  '漫画完结',
];

export const friendLinks = [
  { label: '哔哩哔哩番剧', href: 'https://flclub51.asia' },
  { label: 'Animate Times', href: 'https://www.animatetimes.com' },
  { label: 'Bangumi 番组计划', href: 'https://bangumi.tv' },
  { label: '日本动画协会', href: 'https://aja.gr.jp' },
];